<template>
  <v-card class="create-rbu">
    <v-card-title>
      {{ $t("rbu.create_title") }}
    </v-card-title>
    <v-card-text class="d-flex flex-column">
      <v-form ref="form">
        <!-- <v-combobox
          outlined
          :label="$t('edition.id')"
          :items="editions"
          v-model="result.edition_id"
          :rules="requiredRules"
        ></v-combobox> -->
        <v-text-field
          outlined
          type="text"
          :label="$t('edition.id')"
          v-model="result.edition_id"
          :rules="requiredRules"
        ></v-text-field>
        <v-text-field
          outlined
          type="text"
          :label="$t('rbu.rbu_edition_name')"
          v-model="result.name"
          :rules="requiredRules"
        ></v-text-field>
        <v-combobox
          outlined
          :label="'Type'"
          :items="types"
          item-text="label"
          item-value="value"
          v-model="result.type"
          :rules="requiredRules"
        ></v-combobox>

        <!-- <RbuPeriodInput
          outlined
          :label="$t('rbu.latest')"
          v-model="result.latest"
          :rules="requiredRules"
        ></RbuPeriodInput> -->
        <RbuPeriodInput
          outlined
          :label="$t('rbu.base_start')"
          v-model="result.base_start"
          :rules="requiredRules"
        ></RbuPeriodInput>
        <RbuPeriodInput
          outlined
          :label="$t('rbu.base_end')"
          v-model="result.base_end"
          :rules="requiredRules"
        ></RbuPeriodInput>
        <!-- <v-text-field
          outlined
          type="number"
          min="1"
          :label="$t('rbu.contract_percentage')"
          suffix="%"
          v-model="result.contract_percentage"
          :rules="requiredRules"
        ></v-text-field> -->
        <v-text-field
          outlined
          type="number"
          min="1"
          :label="$t('rbu.tcef')"
          suffix="%"
          v-model="result.tcef"
          :rules="requiredRules"
        ></v-text-field>
        <v-text-field
          outlined
          type="number"
          min="0"
          step=".01"
          suffix="%"
          :label="$t('rbu.head_office_overhead_and_profit')"
          v-model="result.head_office_overhead_and_profit"
          :rules="requiredRules"
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary" @click="$emit('submit', false)" depressed large>
        {{ $t("cancel") }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        @click="$refs.form.validate() && save()"
        depressed
        large
      >
        {{ $t("ok") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { computed, onMounted, ref } from "@vue/composition-api";
import { ACTION_TYPES } from "@/store/types";
import RbuPeriodInput from "@/components/rbu/RbuPeriodInput.vue";

export default {
  name: "CreateRbuEditionDialog",
  components: { RbuPeriodInput },
  setup(props, { root, emit }) {
    const requiredRules = ref([
      (value) => !!value || root.$t("rules.required"),
    ]);

    const editions = ref([]);
    const types = ref([
      { label: "New Edition", value: "NEW_EDITION" },
      { label: "Corrigendum", value: "CORRIGENDUM" },
    ]);
    const isNewEdition = computed(
      () => editions.value.indexOf(result.value.edition) === -1
    );
    const getEditions = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/edition/",
        params: {
          page_size: -1,
        },
      });

      if (response.body.success) {
        editions.value = response.body.editions.map((e) => e.id);
      }
    };

    const result = ref({
      edition: "",
      type: {
        label: "New Edition",
        value: "NEW_EDITION",
      },
    });

    const save = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/edition/create/",
        params: {
          ...result.value,
        },
      });

      if (response.body.success) {
        emit("submit", response.body.edition.id);
      }
    };

    onMounted(() => {
      getEditions();
    });

    return {
      requiredRules,
      editions,
      isNewEdition,
      result,
      save,
      types,
    };
  },
};
</script>
